export let enviromentnode = process.env.REACT_APP_DEVMODE === "active"

//export const endPointCaderno = process.env.REACT_APP_END_POINT_PROCESSO
//export const endPointCaderno = process.env.REACT_APP_END_POINT_COMMONS
export const endPointSuprimentos = process.env.REACT_APP_END_POINT_SUPRIMENTOS
export const endPointTimer = process.env.REACT_APP_END_POINT_TIMER
export const endPointUser = process.env.REACT_APP_END_POINT_USER
export const endPointRabbit = process.env.REACT_APP_END_POINT_RABBIT
export const endPointCorrecao = process.env.REACT_APP_END_POINT_CORRECAO
export const endPointWorkPlan = process.env.REACT_APP_END_POINT_WORKPLAN
export const endPointWhaleTamer = process.env.REACT_APP_END_POINT_WHALETAMER
//export const endPointCaderno =process.env.REACT_APP_END_POINT_PLANODECONTROLE
export const endPointCaderno = process.env.REACT_APP_END_POINT_CADERNO
export const endPointNotification = process.env.REACT_APP_END_POINT_NOTIFICATION
export const endPointCloudFrontS3 = process.env.REACT_APP_END_POINT_AWSS3CLOUDFRONT
export const endPointSGM = process.env.REACT_APP_END_POINT_SGM

export const ids = {
	novoRecursoButton: "novoRecursoButton",
	novaSolicitacaoButton: "novaSolicitacaoButton",
	novaOrdemButton: "novaOrdemButton",
	novoCaderno: "novoCaderno",
	checkActiveRecurso: "checkActiveRecurso",
	editRecursoButton: "editRecursoButton",
	deleteRegistroDeCampo: "deleteRegistroDeCampo",
	solicitacoesDeServicoAcaoColumn: "solicitacoesDeServicoAcaoColumn",
	ordensDeServicoIndicadorButton: "ordensDeServicoIndicadorButton",
	ordensDeServicoTarefasColumn: "ordensDeServicoTarefasColumn",
	ordensDeServicoAcaoColumn: "ordensDeServicoAcaoColumn",
	ordensDeServicoTempoColumn: "ordensDeServicoTempoColumn",
	AbrirOrdemButton: "abrir-ordem-button",
	EditarOrdemButton: "editar-ordem-button",
	UsarModelosDropDown: "ordem-modelos-dropdown",
	removerFolhaButton: "removerFolhaButton",
	solicitacoesDeServicoFilterIconButton: "filterSolicitacoesButton",
	menuBar: {
		planoDeTrabalhoDropdownMenu: "planoDeTrabalhoDropdownMenu",
		gestaoDeParametrosDropdownMenu: "gestaoDeParametrosDropdownMenu",
		contadorDropdownMenu: "contadorDropdownMenu",
		manutencaoDropdownMenu: "manutencaoDropdownMenu",
		processoDropdownMenu: "processoDropdownMenu",
		suprimentosDropdownMenu: "suprimentosDropdownMenu",
	},
}

export const beforeSaveVerifyHandler = (form, addToastCallback) => {
	if (form.recursos.length === 0) {
		addToastCallback("Selecione pelo menos um recurso", {
			appearance: "warning",
			autoDismiss: true,
		})
	} else if (form.descricaoDoProblema.length === 0) {
		addToastCallback("Preencha a descrição do problema", {
			appearance: "warning",
			autoDismiss: true,
		})
	} else if (!form.setorDestino) {
		addToastCallback(
			"Setor responsável pela execução não selecionado. Selecione um setor ou marque a caixa de não atribuição.",
			{
				appearance: "warning",
				autoDismiss: true,
			}
		)
	} /* else if (!form.isSolicitacaoEmergencial) {
		addToastCallback(
			"Selecione o tipo da solicitação.",
			{
				appearance: "warning",
				autoDismiss: true,
			}
		)
	} */ else return true
}

export const validationOptions = {
		number: [
			{
				rule: "-",
				display: "-",
				logicalOperator: "-",
			},
			{
				rule: "input > param",
				display: "Maior que",
				logicalOperator: ">",
			},
			{
				rule: "input >= param",
				display: "Maior ou igual a",
				logicalOperator: ">=",
			},
			{
				rule: "input < param",
				display: "Menor que",
				logicalOperator: "<",
			},
			{
				rule: "input <= param",
				display: "Menor ou igual a",
				logicalOperator: "<=",
			},
			{
				rule: "input === param",
				display: "Igual a",
				logicalOperator: "===",
			},
			{
				rule: "input !== param",
				display: "Diferente de",
				logicalOperator: "!==",
			},
			{
				rule: "input >= min && input <= max",
				display: "Entre",
				logicalOperator: ">=",
			},
			{
				rule: "input < min || input > max",
				display: "Não está entre",
				logicalOperator: "<",
			},
		],

		text: [
			{ rule: 'new RegExp(param).test("input")', display: "Contém" },
			{ rule: '!new RegExp(param).test("input")', display: "Não contém" },
			{
				rule: '/^[w-.]+@([w-]+.)+[w-]{2,4}$/.test("input")',
				display: "É um email",
			},
			{
				rule: '/^(https?://)?([w-]+.)+[w-]{2,4}(/[^s]*)*$/.test("input")',
				display: "É uma URL",
			},
		],
		stringLength: [
			{
				rule: "input.length >= min",
				display: "Número mínimo de caracteres",
			},
			{
				rule: "input.length <= max",
				display: "Número máximo de caracteres",
			},
		],
		regex: [
			{ rule: 'new RegExp(param).test("input")', display: "Contém" },
			{ rule: '!new RegExp(param).test("input")', display: "Não contém" },
			{
				rule: 'new RegExp(`^${param}$`).test("input")',
				display: "Corresponde",
			},
			{
				rule: '!new RegExp(`^${param}$`).test("input")',
				display: "Não corresponde",
			},
		],
	}
//export const endPointCaderno =  "http://localhost:4000/"
//export const endPointManutencao = "https://ordemdemanutencao.scqapi.com/"
//export const endPointSuprimentos = "http://localhost:4014/"
//export const endPointCaderno = "http://localhost:4002/"
//export const endPointTimer = "http://localhost:4030/"
//export const endPointUser = "http://localhost:4018/"
//export const endPointRabbit = "http://localhost:3015/"
//export const endPointCorrecao = "http://localhost:3009/"
//export const endPointMathema = "http://localhost:8001/"
//export const endPointWorkPlan = "http://localhost:4019/"
//export const endPointCaderno = "http://localhost:3054/"
//export const endPointCaderno = "http://localhost:4057/"

export const paths = {
	agregadores: "/agregadores",
	processos: "/processos",
	parametros: "/parametros",
	operacoes: "/operacoes",
	fluxos: "/fluxos",
	acessoNaoPermitido: "/acessoNaoPermitido",
	// Formulários (individuais)
	acaoForm: "/acaoForm",
	// Listagens (todas)
	acoes: "/acoes",
	agregadorForm: "/agregadorForm",
	alarmeForm: "/alarmeForm",
	reporte: "/reporte/:dataInicio/:dataFim/:caderId",
	operacaoForm: "/operacaoForm",
	aprovaStatus: "/aprovacaoStatus",
	arvoreEstruturalForm: "/arvoreEstruturalForm",
	tipoDeOrdemForm: "/tipoDeOrdemForm",
	branchLevelForm: "/branchLevelForm",
	cadernoDeVerificacao: "/cadernoDeVerificacao",
	cadernoDeVerificacaoForm: "/cadernoDeVerificacaoForm",
	campoDeVerificacao: "/campoDeVerificacao",
	classeDeComponenteForm: "/classeDeComponenteForm",
	cadernos: "/cadernos",
	formularioForm: "/formularioForm",
	planosDeControle: "/planosDeControle",
	classeDeRecursoForm: "/classeDeRecursoForm",
	classeDeRecursoPicker: "/classeDeRecursoPicker",
	composicaoForm: "/composicaoForm",
	componenteForm: "/componenteForm",
	controleForm: "/controleForm",
	cronogramaManutencao: "/cronogramaManutencao",
	cadernos: "/cadernos",
	dimensaoForm: "/dimensaoForm",
	estoqueForm: "/estoqueForm",
	estoques: "/estoques",
	especificacaoForm: "/especificacaoForm",
	primeiroLoginForm: "/FirstLogin",
	frequenciaForm: "/frequenciaForm",
	fluxoDeProcessoForm: "/fluxoDeProcessoForm",
	itemDeRequisicao: "/itemDeRequisicao",
	kardex: "/kardex",
	linhaDePlanoDeControleForm: "/linhaDePlanoDeControleForm",
	limiteDeControleForm: "/limiteDeControleForm",
	loginForm: "/Login",
	mantenedores: "/mantenedores",
	mantenedorForm: "/mantenedorForm",
	materialCompostoForm: "/materialCompostoForm",
	materialForm: "/materialForm",
	materiais: "/materiais",
	menu: "/menu",
	parametroForm: "/parametroForm",
	planoDeControleDashboard: "/planoDeControleDashboard",
	planoDeControleForm: "/planoDeControleForm",
	planoDeManutencaoForm: "/planoDeManutencaoForm",
	planosDeManutencao: "/planosDeManutencao",
	processoForm: "/processoForm",
	recorrenciaForm: "/recorrenciaForm",
	registroDeCampoChart: "/registroDeCampoChart",
	registroForm: "/registroForm",
	contadorForm: "/contadorForm",
	timeLineWorkPlan: "/timelineWorkPlan",
	registroDeTarefaForm: "/registroDeTarefaForm",
	requisicaoMaterialForm: "/requisicaoMaterialForm",
	requisicoesDeMaterial: "/requisicoesDeMaterial",
	recursoDisplayer: "/recursoDisplayer",
	recursoPicker: "/recursoPicker",
	recursoForm: "/recursoForm",
	recursos: "/recursos",
	regraDeAgregacaoForm: "/regraDeAgregacaoForm",
	regraDeCorrecaoForm: "/regraDeCorrecaoForm",
	setorForm: "/setorForm",
	solicitacaoDeServicoForm: "/solicitacaoDeServicoForm",
	solicitacoesDeServico: "/solicitacoesDeServico",
	tarefaForm: "/tarefaForm",
	tarefas: "/tarefas",
	templateDeDados: "/templateDeDados",
	testing: "/testingAreaMenu",
	timeForm: "/timeForm",
	times: "/times",
	turnoForm: "/turnoForm",
	unidadeForm: "/unidadeForm",
	unidades: "/unidades",
	unidadeMaterialForm: "/unidadeMaterialForm",
	workPlanForm: "/workPlanForm",
	workPlanExecution: "/workPlanExecution",
	ordemDeManutencaoForm: "/ordemDeManutencaoForm",
	ordensDeManutencao: "/ordensDeManutencao",
	ordemDeServicoForm: "/ordemDeServicoForm",
	ordemDeServico: "/ordemDeServico",
	ordensDeServico: "/ordensDeServico",
	osChart: "/osChart",
	folhaDeVerificacaoForm: "/folhaDeVerificacaoForm",
	modoDeFalhaForm: "/modoDeFalhaForm",
	cadernoDeVerificacaoForm: "/cadernoDeVerificacaoForm",
	campoDeFormularioForm: "/campoDeFormularioForm",
	cronogramaManutencao: "/cronogramaManutencao",
	workForm: "/workForm",
	workPlans: "/planos",
	workPlan: "/workPlan",
	statusGroupForm: "/statusGroupForm",
	statusGroup: "/statusGroup",
	workSpaceForm: "/workSpaceForm",
	workSpaces: "/workSpaces",
	workFlow: "/workFlow",
	workFlows: "/excucoes",
	formularios: "/formularios",
	formularioForm: "/formularioForm",
	ordenacaoDeFolhas: "/ordenacaoDeFolhas",
	controlePicker: "/controlePicker",
	apontarAgregador: "/apontarAgregador",
	C_E_P: "/CEP",
	inspecoesDashboard: "/inspecoesDashboard",
	visaoGeralManutencao: "/ordemDeServico/overview",
	visaoGeralDeMateriaPrima: "/visaoGeralDeMateriaPrima",
	materialConsumptionDashboard: "/consumoDeMateriaPrima",
	agregador: "/agregador",
	planejamentoDeOs: "/planejamentoDeOs",
	modelosDeOrdemDeServico: "/modelosDeOrdemDeServico",
	analisePerformanceCp: "/analisePerformanceCp",
	ordensDeCorrecao: "/ordensDeCorrecao",
	ordemDeCorrecaoForm: "/ordemDeCorrecaoForm",
	ordemDeCorrecaoApontar: "/ordensDeCorrecaoApontar",
}

export const tipoFrequencia = ["DATE", "COUNTER"]
export const estadoStatus = ["PENDENTE", "APROVADO", "REPROVADO"]
export const days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]
export const escala = ["DIA", "HORAS", "MINUTOS", "SEGUNDOS", "MILISEGUNDOS"]
export const tiposDeCampo = [
	{ nome: "Textual", type: "text" },
	{ nome: "Numérico", type: "number" },
	{ nome: "Tempo", type: "time" },
	{ nome: "ƒ(x)", type: "formula" },
]
export const statusColor = (estado) => {
	if (estado === "PENDENTE") return { color: "orange", fontWeight: "bold" }
	if (estado === "REPROVADO") return { color: "red", fontWeight: "bold" }
	if (estado === "APROVADO") return { color: "green", fontWeight: "bold" }
}
export const colors = {
	vermelhoPastel: { H: "#FAA0A0", R: "rgba(250, 160, 160, 0.5)" },
	verdePastel: { H: "#A4FBA6", R: "rgba(164,251,166, 0.5)" },
	cinzaClaro: { H: "#d1d0cd", R: "rgba(143, 142, 140, 0.3)" },
	amareloClaro: { H: "#f5d164", R: "rgba(143, 142, 140, 0.3)" },
	azulClaro: { H: "#6dd1ed", R: "rgba(143, 142, 140, 0.3)" },
	amareloEscuro: { H: "#eecb06", R: "rgba(238, 203, 6, 0.5)" },
}

export const Agrupamentos = { DIA: "dia", SEMANA: "semana", MES: "mes" }

/* export const labels = (language) => {
   return {Valor: {}}
} */

export const version = "0.8.2a"

export const texts = {
visaoGeralManutentorWarning : " A quantidade total de OS de cada status pode não corresponder à soma por manutentor, pois uma mesma ordem pode ter envolvido mais de um profissional na conclusão."
}

export const PERMISSIONS = {
	ANY: 'ANY',
	WRITE_PROCESSO: 'WRITE_PROCESSO',
	READ_PROCESSO: 'READ_PROCESSO',
	WRITE_COMMONS: 'WRITE_COMMONS',
	READ_COMMONS: 'READ_COMMONS',
	WRITE_SUPRIMENTOS: 'WRITE_SUPRIMENTOS',
	READ_SUPRIMENTOS: 'READ_SUPRIMENTOS',
	WRITE_GESTAO: 'WRITE_GESTAO',
	READ_GESTAO: 'READ_GESTAO'
}